const EditDevspecfundsEntcultivation = () => import('../modules/xmsb/energy/operators/EditDevspecfundsEntcultivationGzl')

export default [
  {

    path: '/devspecfundsentcultivationedit',
    name: 'devspecfundsentcultivationedit',
    component: EditDevspecfundsEntcultivation,
    meta: {
      title: '发展专项资金项-专精特新培育企业智能化升级项目',
      fullscreen: true,

    },
  },
]
